
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/feature-requests",
      function () {
        return require("private-next-pages/feature-requests.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/feature-requests"])
      });
    }
  